import {Component, Input, OnInit} from '@angular/core';
import {MatDrawer} from "@angular/material/sidenav";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input()
  drawer: MatDrawer;

  closeOnChange = false;

  constructor(
    public breakpointObserver: BreakpointObserver,
    private router: Router,
    public authService: AuthService
  ) {
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 600px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.closeOnChange = true;
        } else {
          this.closeOnChange = false;
        }
      });
  }

  navigate() {
    if (this.closeOnChange) {
      this.drawer.close();
    }
  }

}
